
import React from 'react';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router';
import { createQueryClient } from './config/queryClient';
import { AuthProvider } from './contexts/AuthContext';
import AppRoutes from './router';

const ErrorFallback: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen bg-[var(--color-background)] items-center justify-center">
      <div className="text-center max-w-md p-8">
        <i className="fas fa-exclamation-triangle text-5xl text-red-500 mb-4"></i>
        <h1 className="text-2xl font-bold text-[var(--color-text)] mb-2">
          {t('errors.unexpected')}
        </h1>
        <p className="text-[var(--color-muted)] mb-6">
          {t('errors.unexpectedDesc')}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-3 bg-[var(--color-accent)] text-[var(--color-background)] font-bold rounded-lg hover:bg-[var(--color-accent)]/80 transition-colors"
        >
          {t('errors.reloadPage')}
        </button>
      </div>
    </div>
  );
};

// O cache é escopado por curso — ver config/queryClient.ts.
const queryClient = createQueryClient();

// Só a composição de providers: quem decide o que está na tela é o router.
const App: React.FC = () => {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
};

export default App;
